import s from '../solution-rate-reviews.scss';
import { config } from '../../../../../config/config';
import React, { useEffect } from 'react';
import { SortDropDown } from '..';
import { ModalNames } from '../../../../modals/modals';
import { SolutionPageCtx } from '../../..';
import { Origin } from '../../../../..';
import { composer } from '../../../../../component-decorators/composer';
import { biLogger } from '../../../../../bi';
import { TextButton, Text } from 'wix-style-react';
import { BlockReviewsHelper } from './block-reviews-helper';
import { useConfigContext } from "../../../../../config-context";
export var ReviewsSectionHeader = composer()
    .withExperiments()
    .withMarketplaceStore()
    .withTranslation()
    .compose(function (_a) {
    var editMode = _a.editMode, experiments = _a.experiments, marketplaceStore = _a.marketplaceStore, t = _a.t, afterPostRender = _a.afterPostRender, reviews = _a.reviews, sortBy = _a.sortBy, showDeletedLink = _a.showDeletedLink, isEligibleForReviews = _a.isEligibleForReviews, appId = _a.appId;
    // tslint:disable-next-line:react-hooks-nesting
    var isMobile = useConfigContext().isMobile;
    var openModal = function (app, eligibleForReviews) {
        if (eligibleForReviews === false) {
            if (!isHelperOpen) {
                biLogger.appMarketReviewAppNotInstalledAlert({
                    app_id: app === null || app === void 0 ? void 0 : app.baseInfo.id,
                });
            }
            setOpenHelper(!isHelperOpen);
            return;
        }
        editMode && editMode.shouldDisplay
            ? openEditModal(app)
            : openPostModal(app);
    };
    var openPostModal = function (app) {
        marketplaceStore.openModal(ModalNames.RATE_APP, {
            app: app,
            closeModal: function () { return closeReviewModal(app); },
            optionCB: afterPostRender,
        });
    };
    var closeReviewModal = function (app) {
        marketplaceStore.closeAllModals();
    };
    var openEditModal = function (app) {
        marketplaceStore.openModal(ModalNames.EDIT_REVIEW, {
            app: app,
            closeModal: function () { return closeReviewModal(app); },
            optionCB: afterPostRender,
            userReview: editMode.userReview,
        });
    };
    // tslint:disable-next-line:react-hooks-nesting
    var _b = React.useState(false), isHelperOpen = _b[0], setOpenHelper = _b[1];
    // tslint:disable-next-line:react-hooks-nesting
    useEffect(function () {
        if (isHelperOpen) {
            setOpenHelper(false);
        }
    }, [appId]);
    return (React.createElement("div", { className: s.reviewsHeaderContainer },
        React.createElement("div", { className: s.sortByContainer },
            React.createElement(ReviewsTitle, { reviews: reviews }),
            React.createElement(SortDropDown, { sortBy: sortBy, isMobile: isMobile })),
        config.origin === Origin.STANDALONE &&
            !marketplaceStore.userName ? null : showDeletedLink ? (React.createElement(ReviewDeleted, null)) : (React.createElement(Text, { className: s.openRateModalLink },
            editMode && !editMode.shouldDisplay && (React.createElement(TranslatedKey, { tkey: 'solution.page.reviews.triedThisApp' })),
            React.createElement(SolutionPageCtx.Consumer, null, function (value) { return (React.createElement(TextButton, { dataHook: "add-review", onClick: function () { return openModal(value === null || value === void 0 ? void 0 : value.app, isEligibleForReviews); } }, editMode && editMode.shouldDisplay ? (React.createElement(TranslatedKey, { tkey: 'solution.page.reviews.editYourReview' })) :
                React.createElement(BlockReviewsHelper, { app: value === null || value === void 0 ? void 0 : value.app, opened: isHelperOpen, target: 'solution.page.reviews.shareYourFeedBack' }))); })))));
});
var ReviewDeleted = composer()
    .withTranslation()
    .compose(function (props) {
    return (React.createElement(Text, { className: s.openRateModalLink },
        props.t('solution.page.review.deletedText'),
        React.createElement("br", null),
        props.t('solution.page.review.please'),
        React.createElement(TextButton, { as: "a", target: "_blank", href: "https://www.wix.com/support/html5/wix-app-market/adding-apps-to-your-site/kb/why-was-my-app-review-removed" }, props.t('solution.page.review.deletedLink'))));
});
var TranslatedKey = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, tkey = _a.tkey;
    return t(tkey);
});
var ReviewsTitle = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, reviews = _a.reviews;
    return (React.createElement(Text, { size: "medium", weight: "normal", dataHook: "solution-reviews-title", className: s.reviewTitle }, t('solution.page.reviewsHeaderTitle', {
        reviews: reviews,
    })));
});
//# sourceMappingURL=reviews-section-header.js.map